import MojitoCore from 'mojito/core';
import SelectionsLimitToast from './selections-limit-toast.jsx';

/**
 * View for SelectionsLimit Toast.
 *
 * @class SelectionsLimitToast
 * @memberof Mojito.Modules
 */
export default MojitoCore.Presentation.UIView('SelectionsLimitToast', SelectionsLimitToast);
